const default_sovrn_config = {
  active: true,

  coppa__false: {

    'efe_hp_728': {
      '728x90': {
        tagid: '644770',
      },
      '970x90': {
        tagid: '644771'
      },
      '970x250': {
        tagid: '644772'
      }
    },

    'efe_topics_160': {
      '160x600': {
        tagid: '644771'
      },
      '120x600': {
        tagid: '644772'
      }
    },

    'efe_topics_bottom_728': {
      '728x90': {
        tagid: '644758',
      },
      '970x90': {
        tagid: '644759'
      },
      '970x250': {
        tagid: '644760'
      }
    },
    'efe_topics_mid_728_1': {
      '728x90': {
        tagid: '644761',
      },
      '970x90': {
        tagid: '644762'
      },
      '970x250': {
        tagid: '644763'
      }
    },
    'efe_topics_mid_728_2': {
      '728x90': {
        tagid: '644764',
      },
      '970x90': {
        tagid: '644765'
      },
      '970x250': {
        tagid: '644766'
      }
    },
    'efe_topics_mid_728_3': {
      '728x90': {
        tagid: '644767',
      },
      '970x90': {
        tagid: '644768'
      },
      '970x250': {
        tagid: '644769'
      }
    },
    'efe_300_mid': {

      '300x250': {
        tagid: '644775',
      },
      '336x280': {
        tagid: '644776'
      },
      '250x250': {
        tagid: '644777'
      }
    },
    'EFE_PDF_Top': {
      '728x90': {
        tagid: '663054',
      },
      '970x90': {
        tagid: '663055'
      },
      '970x250': {
        tagid: '663056'
      }
    },
    'EFE_PDF_Bottom': {
      '728x90': {
        tagid: '663057',
      },
      '970x90': {
        tagid: '663058'
      },
      '970x250': {
        tagid: '663059'
      }
    },
    'EFE_Right_Sticky': {
      '160x600': {
        tagid: '663060',
      },
      '120x600': {
        tagid: '663061'
      },
      '300x600': {
        tagid: '663062'
      },
      '300x250': {
        tagid: '663063'
      },
    }

  },

  coppa__true: {}

};
export const sovrn_config = default_sovrn_config;
